export const PUBLIC_URL = process.env.PUBLIC_URL;
export const IS_PROD = process.env.REACT_APP_IS_PROD;

const getCurrentDomain = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '';
};

const DOMAIN_CONFIGS = {
  'lk.programmatic.ru': {
    brand: 'programmatic',
    title: 'Programmatic',
    faviconPath: '/domains/programmatic/favicon.ico',
    manifestPath: '/domains/programmatic/manifest.json',
    logoPath: '/domains/programmatic/logo192.png',
    apiHost: 'https://api.programmatic.ru'
  },
  'lk-beta.programmatic.ru': {
    brand: 'programmatic',
    title: 'Programmatic Beta',
    faviconPath: '/domains/programmatic/favicon.ico',
    manifestPath: '/domains/programmatic/manifest.json',
    logoPath: '/domains/programmatic/logo192.png',
    apiHost: 'https://lk-beta-api.programmatic.ru'
  },
  'lk.retargeo.ru': {
    brand: 'retargeo',
    title: 'Retargeo',
    faviconPath: '/domains/retargeo/favicon.ico',
    manifestPath: '/domains/retargeo/manifest.json',
    logoPath: '/domains/retargeo/logo192.png',
    apiHost: 'https://api.retargeo.ru'
  },
  'lk-beta.retargeo.ru': {
    brand: 'retargeo',
    title: 'Retargeo Beta',
    faviconPath: '/domains/retargeo/favicon.ico',
    manifestPath: '/domains/retargeo/manifest.json',
    logoPath: '/domains/retargeo/logo192.png',
    apiHost: 'https://lk-beta-api.retargeo.ru'
  },
  'localhost': {
    brand: 'retargeo',
    title: 'Programmatic Dev',
    faviconPath: '/domains/programmatic/favicon.ico',
    manifestPath: '/domains/programmatic/manifest.json',
    logoPath: '/domains/programmatic/logo192.png',
    apiHost: 'https://api.programmatic.ru'
  }
};

export const getDomainConfig = () => {
  const currentDomain = getCurrentDomain();

  if (DOMAIN_CONFIGS[currentDomain]) {
    return DOMAIN_CONFIGS[currentDomain];
  }

  return DOMAIN_CONFIGS['lk.programmatic.ru'];
};

export const DOMAIN_CONFIG = getDomainConfig();

export const DOMAIN_API_HOST = DOMAIN_CONFIG.apiHost;
